import { render, staticRenderFns } from "./block-organization-payments.vue?vue&type=template&id=ae48f5a8&scoped=true&lang=pug"
import script from "./block-organization-payments.vue?vue&type=script&lang=js"
export * from "./block-organization-payments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae48f5a8",
  null
  
)

export default component.exports